import React from "react";
import Image from "../../images/deroulement.png";

const Description = () => {
  return (
    <div style={styles.div}>
      <img style={styles.image} src={Image} alt="Deroulement" />
    </div>
  );
};

export default Description;

const styles = {
  image: {
    width: "100%",
  },
  div: {
    background: "linear-gradient(to bottom, #ffffff,rgba(230, 100, 0, 0.5))", // Dégradé de couleur
    paddingRight: 10,
    paddingLeft: 10,

    paddingTop: 30,
    paddingBottom: 30,
    width: "100%",
  },
};
